module.exports = __webpack_public_path__ + "static/media/cases_3d_01c.fb1b397d.jpg";